import React from "react"
import PropTypes from 'prop-types'
import { Link, useNavigate } from "react-router-dom"
import { Row, Col, BreadcrumbItem } from "reactstrap"

const Breadcrumb = props => {
  const navigate = useNavigate()
  return (
    <Row>
      <Col className="col-12">
        <div className="page-title-box d-sm-flex align-items-center justify-content-between">
          <h4 className="mb-sm-0 font-size-18" style={{cursor: props.isBack == 'yes' ? "pointer" : ""}} onClick={() => props.isBack == 'yes' ? navigate(-1) : ""} >{props.breadcrumbItemText ? props.breadcrumbItemText : props.breadcrumbItem}</h4>
          {/* <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <BreadcrumbItem>
                <Link to="#">{props.title}</Link>
              </BreadcrumbItem>
              <BreadcrumbItem active={!props.breadcrumbItemText && true}>
                <Link to="#">{props.breadcrumbItem}</Link>
              </BreadcrumbItem>
              {
                props.breadcrumbItemText
                  ?
                  <BreadcrumbItem active>
                    <Link to="#">{props.breadcrumbItemText}</Link>
                  </BreadcrumbItem>
                  :
                  ""
              }
            </ol>
          </div> */}
        </div>
      </Col>
    </Row>
  )
}

Breadcrumb.propTypes = {
  breadcrumbItem: PropTypes.string,
  title: PropTypes.string
}

export default Breadcrumb
